export interface FreeBattleSupplyDefinition {
  cardId: string;
  cost: number;
  limited: boolean;
}

export interface OpeningImpressionDefinition {
  cardId: string;
  interpretation: string;
}

export const COMMON_FREE_BATTLE_SUPPLY: readonly FreeBattleSupplyDefinition[] = Object.freeze([
  Object.freeze({ cardId: "cloud", cost: 2, limited: false }),
  Object.freeze({ cardId: "wind", cost: 2, limited: false }),
  Object.freeze({ cardId: "sink", cost: 2, limited: false }),
  Object.freeze({ cardId: "rise", cost: 2, limited: false }),
  Object.freeze({ cardId: "apple", cost: 3, limited: false }),
  Object.freeze({ cardId: "snake", cost: 3, limited: false }),
]);

export const STAGE_FREE_BATTLE_SUPPLY: Readonly<Record<string, readonly FreeBattleSupplyDefinition[]>> = Object.freeze({
  "looping-street": Object.freeze([
    Object.freeze({ cardId: "familiar_lamppost", cost: 3, limited: true }),
    Object.freeze({ cardId: "red_ball", cost: 3, limited: true }),
    Object.freeze({ cardId: "one_more_lap", cost: 3, limited: true }),
    Object.freeze({ cardId: "way_home", cost: 5, limited: true }),
  ]),
  "dragon-adventure": Object.freeze([
    Object.freeze({ cardId: "story_hero_boots", cost: 3, limited: true }),
    Object.freeze({ cardId: "story_distant_roar", cost: 3, limited: true }),
    Object.freeze({ cardId: "story_first_aid", cost: 2, limited: true }),
    Object.freeze({ cardId: "story_injured_dragon", cost: 3, limited: true }),
  ]),
  fireside: Object.freeze([
    Object.freeze({ cardId: "burnt_cookies", cost: 2, limited: true }),
    Object.freeze({ cardId: "hearth_fire", cost: 4, limited: true }),
    Object.freeze({ cardId: "falling_snow", cost: 3, limited: true }),
    Object.freeze({ cardId: "rewrapped_gift", cost: 4, limited: true }),
  ]),
  "winter-plaza": Object.freeze([
    Object.freeze({ cardId: "street_piano", cost: 3, limited: true }),
    Object.freeze({ cardId: "faceless_crowd", cost: 3, limited: true }),
    Object.freeze({ cardId: "encore", cost: 4, limited: true }),
    Object.freeze({ cardId: "turn_back_clock", cost: 5, limited: true }),
  ]),
  "rain-study": Object.freeze([
    Object.freeze({ cardId: "stubborn_stain", cost: 2, limited: true }),
    Object.freeze({ cardId: "steaming_tea", cost: 2, limited: true }),
    Object.freeze({ cardId: "layered_time", cost: 4, limited: true }),
    Object.freeze({ cardId: "long_holiday", cost: 4, limited: true }),
  ]),
  "layered-stage": Object.freeze([
    Object.freeze({ cardId: "lingering_note", cost: 3, limited: true }),
    Object.freeze({ cardId: "rest_note", cost: 3, limited: true }),
    Object.freeze({ cardId: "harmony", cost: 4, limited: true }),
    Object.freeze({ cardId: "seventh_note", cost: 5, limited: true }),
  ]),
});

const allSupplyCards = [
  ...COMMON_FREE_BATTLE_SUPPLY,
  ...Object.values(STAGE_FREE_BATTLE_SUPPLY).flat(),
];

export const FREE_BATTLE_SUPPLY: readonly FreeBattleSupplyDefinition[] = Object.freeze(
  allSupplyCards.filter((entry, index) => (
    allSupplyCards.findIndex((candidate) => candidate.cardId === entry.cardId) === index
  )),
);

export const OPENING_IMPRESSIONS: readonly OpeningImpressionDefinition[] = Object.freeze([
  Object.freeze({ cardId: "candle", interpretation: "帰る場所を忘れない" }),
  Object.freeze({ cardId: "door", interpretation: "答えを急がず、扉の前で考える" }),
  Object.freeze({ cardId: "cloud", interpretation: "心地よい場所へ身を預けやすい" }),
  Object.freeze({ cardId: "thorn", interpretation: "近づくものへ、先に身構える" }),
  Object.freeze({ cardId: "sleeping_moss", interpretation: "不安の中にも柔らかな足場を探す" }),
  Object.freeze({ cardId: "mirror_passenger", interpretation: "他者の表情に自分を映している" }),
]);

export function getFreeBattleSupply(stageId: string | undefined): readonly FreeBattleSupplyDefinition[] {
  const stageCards = STAGE_FREE_BATTLE_SUPPLY[stageId ?? ""]
    ?? STAGE_FREE_BATTLE_SUPPLY["looping-street"]
    ?? [];
  return [...COMMON_FREE_BATTLE_SUPPLY, ...stageCards];
}

export function getFreeBattleSupplyCard(
  cardId: string,
  stageId?: string,
): FreeBattleSupplyDefinition | null {
  const supply = stageId ? getFreeBattleSupply(stageId) : FREE_BATTLE_SUPPLY;
  return supply.find((entry) => entry.cardId === cardId) ?? null;
}

export function getOpeningImpression(cardId: string): OpeningImpressionDefinition | null {
  return OPENING_IMPRESSIONS.find((entry) => entry.cardId === cardId) ?? null;
}
